module.exports = __webpack_public_path__ + "static/media/bg_whats-on.ce7d440f.jpeg";